export const ACCESS_TYPE_PORTFOLIO = "b665c0eb-3c96-11ea-b5bd-00ff12c3b408";
export const ACCESS_TYPE_PIPELINE = "b665c4ed-3c96-11ea-b5bd-00ff12c3b408";
export const ACCESS_TYPE_GROUP = "b665c4fb-3c96-11ea-b5bd-00ff12c3b408";
export const ACCESS_TYPE_PORTFOLIO_DEAL = "b665c4ff-3c96-11ea-b5bd-00ff12c3b408";
export const ACCESS_TYPE_PIPELINE_DEAL = "3b17d7c5-3d55-11ea-b5bd-00ff12c3b408";
export const ACCESS_TYPE_LOAN = "b665c503-3c96-11ea-b5bd-00ff12c3b408";
export const ACCESS_TYPES = {
  ACCESS_TYPE_PORTFOLIO,
  ACCESS_TYPE_PIPELINE,
  ACCESS_TYPE_GROUP,
  ACCESS_TYPE_PORTFOLIO_DEAL,
  ACCESS_TYPE_PIPELINE_DEAL,
  ACCESS_TYPE_LOAN
};
